export class TokenUpdatedMessage {
    public readonly _typeName: string = "Modutecture.WebApi.Message.TokenUpdatedMessage";

    public accessToken: string;
    public expiresOn?: Date;
    public authority?: string;

    constructor(accessToken: string, expiresOn?: Date, authority?: string) {
        this.accessToken = accessToken;
        this.expiresOn = expiresOn;
        this.authority = authority;
    }
}
